export const MIN_SIGNED_BY_LENGTH: number = 3;

export const ERROR_CODES = {
    TENANT_DISABLED: 'TenantDisabled'
}
